//import { PaymentRequestButtonElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { Button, Checkbox, Col, Layout, Row, Space, Spin, Typography, message } from "antd";
import Cookies from "js-cookie";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import NewArrowLeftIcon from "../../../assets/icons/new-arrow-left.svg";
import LockIcon from "../../../assets/icons/payment-lock.svg";
import InfoPaymentImg from "../../../assets/images/info-payment.webp";
import TheApplePayButton from "../../../components/ApplePayButton/TheApplePayButton";
import AuthButtonComponent from "../../../components/AuthButtonCompnent";
import CountryDropdownComponent from "../../../components/CountryDropdownComponent/CountryDropdownComponent";
import FanPaymentPopUp from "../../../components/FanPaymentPopUp";
import InputComponent from "../../../components/InputComponent";
import ConfirmationEventPaymentModal from "../../../components/LiveEventComponent/ConfirmationEventPaymentModal";
import SpinnerComponent from "../../../components/SpinnerComponent/SpinnerComponent";
import { REQUEST_LOADING_STATES } from "../../../helpers/constant";
import { ICardInfos, IVerifyPromoCode } from "../../../helpers/types";
import useFetchRtmpStream from "../../../hooks/userHooks/useFetchRTMPStream";
import useFetchUserInfos from "../../../hooks/userHooks/useFetchUserInfos";
import useFetchVatCountries from "../../../hooks/userHooks/useFetchVatCountries";
import { updateRTMPLivePayment } from "../../../redux/lives/livesSlice";
import { AppDispatch } from "../../../redux/store";
import { liveService, promotionService, utilService } from "../../../services";
import { settingService } from "../../../services/settings.service";
import { PAYMENT_ERROR_MESSAGES, SHIFT4_AS_DEFAULT_PAYMENT_GATEWAY } from "../../../utls/constants";
import { COUNTRIES } from "../../../utls/CountryUtil";
import { CARD_MONTH_YEAR_REGEX, CARD_NUMBER_REGEX, CURRENT_YEAR, CVV_REGEX, formatCardNumber } from "../../../utls/FunctionsUtil";
import "./index.less";

// interface ApplePayData {
//   _canMakePaymentAvailability: any;
// }

const FanPaymentRTMPPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const searchParams = new URLSearchParams(location.search);
  const fromDirectStreamPage = searchParams.get("fln");
  const [Key, setKey] = useState("");
  const countries = COUNTRIES;
  const { currentUser, loading: userLoading } = useFetchUserInfos();
  const { rtmpLiveLoading, rtmpLive } = useFetchRtmpStream();
  const { loading: countryLoading, countries: vatCountries } = useFetchVatCountries();

  const shouldFetchCountry = useRef(true);
  // const stripe = useStripe();
  // const elements = useElements();
  const [NetPaymentAoumt, setNetPaymentAoumt] = useState<number>(0);
  //const [paymentRequest, setPaymentRequest] = useState<PaymentRequest | any>();
  const [paymentStatus, setpaymentStatus] = useState<string>();
  const [isApplePay, setIsApplePay] = useState<boolean>(false);
  //const [showApplePay, setShowApplyPay] = useState<string | any>(undefined);

  //const [applePay, setApplePay] = useState<ApplePayData>();

  // card details

  const [cardInfos, setCardInfos] = useState<ICardInfos>({
    expireDate: "",
    cardNumber: "",
    cvv: "",
  });

  const [error, setError] = useState("");

  //const [paymentMethod, setPaymentMethod] = useState<string>();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  // check box
  const [checkboxChecked, setCheckboxChecked] = useState(true);
  const [country, setCountry] = useState("");

  const [vatPercentage, setVatPercentage] = useState<any>(0);

  const [errorFields, setErrorFields] = useState<string[]>([]);

  //const [payemntGateway, setPayemntGateway] = useState<string>("shift4");
  //const payemntGateway = SHIFT4_AS_DEFAULT_PAYMENT_GATEWAY;
  //const [errorFields, setErrorFields] = useState<string[]>([]);

  const COOKIE_USER_COUNTRY = Cookies.get("country");

  // Code promo
  const [promoCode, setPromoCode] = useState("");
  const [applyPromoCodeLoading, setApplyPromoCodeLoading] = useState<boolean>(false);
  const [creatorCode, setCreatorCode] = useState("");
  const [promoCodeDetails, setPromoCodeDetails] = useState<IVerifyPromoCode | null>();
  const [promoCodeDiscount, setPromoCodeDiscount] = useState<number>();
  const applyCreatorPromoCode = useRef<boolean>(false);

  if (Key !== "Backspace") {
    if (cardInfos.expireDate.length === 2) {
      setCardInfos((preStat) => ({
        ...preStat,
        expireDate: cardInfos.expireDate + "/",
      }));
    }
  }

  useEffect(() => {
    // TODO: check this code after fight event
    const creatorCodeLS = localStorage.getItem("creatorCode");
    if (creatorCodeLS && creatorCodeLS !== "" && !applyCreatorPromoCode.current && rtmpLive) {
      setCreatorCode(creatorCodeLS);
      applyCreatorPromoCode.current = true;
      promoCodeApply(creatorCodeLS);
    }
  }, [rtmpLive]);

  useEffect(() => {
    if (promoCodeDetails) {
      if (rtmpLive && rtmpLive.amount && promoCodeDetails?.discountType === "PERCENTAGE") {
        setNetPaymentAoumt(rtmpLive.amount - (rtmpLive.amount * promoCodeDetails.discount) / 100);
      } else if (promoCodeDetails?.discountType === "CURRENCY" && rtmpLive && rtmpLive.amount) {
        setNetPaymentAoumt(rtmpLive.amount - promoCodeDetails.discount);
      }
    }
  }, [promoCodeDetails, rtmpLive]);

  const handleCheckboxChange = () => {
    setCheckboxChecked(!checkboxChecked);
  };

  useEffect(() => {
    getCurrentPaymentGateway();
    if (COOKIE_USER_COUNTRY && COOKIE_USER_COUNTRY !== null) {
      setCountry(COOKIE_USER_COUNTRY);
      const selected = vatCountries?.find((item: any) => item.country === COOKIE_USER_COUNTRY);
      if (selected) {
        setVatPercentage(selected?.vat);
      } else {
        setVatPercentage(0);
      }
    } else {
      if (vatCountries && countries && !country) {
        if (shouldFetchCountry.current) {
          shouldFetchCountry.current = false;
          utilService.fetchUserCountry().then((res: any) => {
            if (res) {
              setCountry(res);
              Cookies.set("country", res, { expires: 1 });
            }
          });
        }
      }
    }
  }, [vatCountries, countries, COOKIE_USER_COUNTRY]);

  // // apply pay
  // useEffect(() => {
  //   if (!stripe || !elements) {
  //     return;
  //   }
  //   setPaymentRequest(null);
  //   const applePay = async (Amount: number) => {
  //     let label = `Payment to $creatorId by ${authService.getId()}`;
  //     let currency = "eur";
  //     let country = "BE";

  //     const pr = stripe.paymentRequest({
  //       currency: currency,
  //       country: country,
  //       requestPayerEmail: true,
  //       requestPayerName: true,
  //       total: {
  //         label: label,
  //         amount: Amount,
  //       },
  //     });

  //     await pr.canMakePayment().then(async (result) => {
  //       if (result) {
  //         setPaymentRequest(pr);
  //       }
  //     });

  //     await pr.on("paymentmethod", async (event) => {
  //       const paymentMethod = event.paymentMethod;

  //       if (paymentMethod) {
  //         const paymentMethodId = event.paymentMethod.id;
  //         // for Server side Stripe-API handling of payment
  //       }
  //       event.complete("success"); // Completes the transaction and closes Google/Apple pay
  //     });
  //   };

  //   applePay(NetPaymentAoumt);
  // }, [stripe, elements, NetPaymentAoumt]);

  // useEffect(() => {
  //   // THIS WILL RUN WHEN THERE'S A CHANGE IN 'quotes'
  //   setShowApplyPay(JSON.stringify(paymentRequest));
  // }, [paymentRequest]);

  // useEffect(() => {
  //   if (showApplePay) {
  //     setApplePay(JSON.parse(showApplePay));
  //   }
  // }, [showApplePay]);

  const buildLivePaymentRequest = () => {
    const [expiryMonth, expiryYear] = cardInfos.expireDate.split("/");
    return {
      liveId: rtmpLive?._id!,
      cardNumber: parseInt(cardInfos.cardNumber.replace(/\s/g, "")),
      expiryMonth: parseInt(expiryMonth),
      expiryYear: 2000 + parseInt(expiryYear),
      cvv: parseInt(cardInfos.cvv),
      paymentGateway: SHIFT4_AS_DEFAULT_PAYMENT_GATEWAY,
      country: country,
      // TODO: check this code after fight event
      promoCode: promoCode || creatorCode || "",
      cardHolderName: `${currentUser?.infos?.firstName} ${currentUser?.infos?.lastName}`,
      savedCard: true,
      isCardToken: false,
      token: "",
    };
  };

  useEffect(() => {
    if (country) {
      const selected = vatCountries?.find((item: any) => item.country === country);
      if (selected) {
        setVatPercentage(selected?.vat);
      } else {
        setVatPercentage(0);
      }
    }
  }, [country]);

  const getCurrentPaymentGateway = async () => {
    await settingService.getPayentGateway().then((res: any) => {
      if (res?.applePayPaysafe) {
        setIsApplePay(res?.applePayPaysafe === "enable");
      }
    });
  };

  const handleCardInfosChange = (e: ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;

    if (name === "cardNumber" && value.match(CARD_NUMBER_REGEX)) {
      setCardInfos((preStat) => ({
        ...preStat,
        cardNumber: formatCardNumber(value),
      }));
    }
    //if (name === "expireDate" && value.match(CARD_MONTH_YEAR_REGEX)) {

    // const [month, year] = value.split("/");

    // const inputYear = parseInt(year, 10);
    // const inputMonth = parseInt(month, 10);
    // setCardInfos((preStat) => ({
    //   ...preStat,
    //   expireDate: value,
    // }));
    // if (inputYear) {
    //   if (inputYear >= parseInt(CURRENT_YEAR, 10) && inputMonth <= 12) {
    //     setCardInfos((preStat) => ({
    //       ...preStat,
    //       expireDate: value,
    //     }));
    //     setError("");
    //   } else {
    //     setError("Enter Valid Expiry Month and Year");
    //   }
    // }
    //}

    if (name === "cvv" && value.match(CVV_REGEX)) {
      setCardInfos((preStat) => ({
        ...preStat,
        cvv: value,
      }));
    }
  };

  const handleCheckErrors = () => {
    let hasError = false;
    if (!cardInfos.cardNumber || !cardInfos.cvv || !cardInfos.expireDate || !buildLivePaymentRequest().country) {
      const errorIn: string[] = [];
      if (!cardInfos.cardNumber) {
        errorIn.push("cardNumber");
        hasError = true;
      }
      if (!cardInfos.cvv) {
        errorIn.push("cvv");
        hasError = true;
      }
      if (!cardInfos.expireDate) {
        errorIn.push("monthYear");
        hasError = true;
      }
      if (!buildLivePaymentRequest().country) {
        errorIn.push("country");
        hasError = true;
      }
      setErrorFields(errorIn);
      return message.warning(t("fill-all-fields"));
    }
    if (buildLivePaymentRequest().country === "Pays") {
      setErrorFields(["country"]);
      hasError = true;
      return message.warning(t("country-required"));
    }
    if (cardInfos.cvv.length < 3) {
      setErrorFields(["cvv"]);
      hasError = true;
      return message.warning(t("valid-cvv"));
    }

    return hasError;
  };

  // handlePayment btn
  const handlePayment = (token: any) => {
    let mainAmount = calculateAmount();
    if (!mainAmount || Number(mainAmount) < 1) {
      message.error(t("no-amount"));
      setIsLoading(false);
      return;
    }

    if (handleCheckErrors()) {
      return;
    }

    if (error) {
      setIsLoading(false);
      return message.warning(error);
    }
    setIsLoading(true);
    if (rtmpLive && rtmpLive._id) {
      liveService.stripeLive({ ...buildLivePaymentRequest(), token }).then((res: any) => {
        setIsLoading(false);
        if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
          return message.error(t(res.message));
        }
        if (res?.transaction?.redirectUrl) {
          const { token, transactionId, redirectUrl } = res.transaction;
          Cookies.set(
            "subscription_data",
            JSON.stringify({
              token: token?.id,
              transactionId,
              creatorId: rtmpLive && rtmpLive.creator && rtmpLive.creator,
              planId: "",
              type: "live",
              username: currentUser?.infos?.username,
              liveId: rtmpLive._id,
              isRTMP: true,
              isLiveStarted: fromDirectStreamPage !== undefined && fromDirectStreamPage !== "",
              isScheduled: "schedule",
            })
          );
          window.location.href = redirectUrl;
        } else {
          if (res?.transaction?.status === "success") {
            setpaymentStatus(res?.transaction?.status);
            dispatch(updateRTMPLivePayment());
            // TODO: check this code after fight event
            if (localStorage.getItem("creatorCode")) {
              localStorage.removeItem("creatorCode");
            }
          } else {
            setpaymentStatus("error");
          }
        }
      });
    }
  };

  const handleApplePayPayment = async (billingAddress: any, token: any) => {
    const userPayload = await utilService.fetchClientDetails();
    setIsLoading(true);
    if (rtmpLive && rtmpLive._id) {
      let data: any = {
        applePay: {
          applePayPaymentToken: token,
        },
        paymentGateway: "paysafe_applepay",
        country: country || null,
        promoCode: promoCode || creatorCode || "",
        liveId: rtmpLive?._id,
      };

      liveService.paysafeApplePayStream({ ...data, ...userPayload }).then((res: any) => {
        setIsLoading(false);
        if (res.statusCode === 400 && PAYMENT_ERROR_MESSAGES.includes(res.message)) {
          return message.error(t(res.message));
        }
        if (res?.data?.status === "success") {
          setpaymentStatus(res?.data?.status);
        } else {
          setpaymentStatus("error");
        }
      });
    }
  };

  const promoCodeApply = async (code?: string | undefined) => {
    let discountedType = "STREAM";
    if (!rtmpLive || !rtmpLive?.creator || !rtmpLive?._id || !rtmpLive?.amount) return;
    let purchaseID = rtmpLive?._id!;
    setApplyPromoCodeLoading(true);
    const creatorId = typeof rtmpLive?.creator === "string" ? rtmpLive?.creator : (rtmpLive?.creator._id as string);
    await promotionService
      .verifyPromoCode(code || promoCode, creatorId, discountedType, purchaseID)
      .then((response: any) => {
        if ("promoOn" in response) {
          if (response?.promoOn === "STREAM") {
            if (response?.discountType === "PERCENTAGE") {
              if (response.discount > 0) {
                if (rtmpLive && rtmpLive?.amount && rtmpLive?.amount - (rtmpLive?.amount * response.discount) / 100 < 1) {
                  setPromoCodeDetails(response as IVerifyPromoCode);
                  setPromoCodeDiscount(rtmpLive?.amount - 1);
                  message.warning(t("minimum-amount"));
                  return;
                } else {
                  setPromoCodeDetails(response as IVerifyPromoCode);
                  setPromoCodeDiscount((rtmpLive.amount! * response.discount) / 100);
                  message.success(t("promo-code-applied"));
                }
              }
            } else {
              if (rtmpLive.amount! - response.discount < 1) {
                setPromoCodeDetails(response as IVerifyPromoCode);
                setPromoCodeDiscount(rtmpLive.amount! - 1);
                message.warning(t("minimum-amount"));
                return;
              } else {
                setPromoCodeDetails(response as IVerifyPromoCode);
                setPromoCodeDiscount(response.discount);
                message.success(t("promo-code-applied"));
              }
            }
          } else {
            message.error(t("enter-valid-promo-code"));
            setPromoCode("");
            setPromoCodeDiscount(0);
            setPromoCodeDetails(null);
          }
        } else if ("error" in response) {
          setPromoCode("");
          setPromoCodeDiscount(0);
          setPromoCodeDetails(null);
          if (response.error) {
            message.error(t(response.error.toLocaleLowerCase().replaceAll("_", "-")));
          } else {
            message.error(t("enter-valid-promo-code"));
          }
        }
        setApplyPromoCodeLoading(false);
      })
      .catch((error: any) => {
        setPromoCode("");
        message.error(t(error));
        setApplyPromoCodeLoading(false);
      });
  };

  const isDataLoading = () => {
    return isLoading || userLoading === REQUEST_LOADING_STATES.PENDING || rtmpLiveLoading || countryLoading === REQUEST_LOADING_STATES.PENDING;
  };

  const calculateAmount = () => {
    let baseAmount = rtmpLive?.amount || 0;
    if (promoCodeDiscount) {
      baseAmount -= promoCodeDiscount;
    }
    return baseAmount?.toFixed(2);
  };

  const handleCloseConfirmModal = () => {
    if (fromDirectStreamPage && fromDirectStreamPage === "rtlf" && rtmpLive && rtmpLive.isStreaming) {
      navigate(`/fan/live/${rtmpLive._id}?from=paymentPage`);
    } else {
      navigate("/p/fan/lives?schedule");
    }
  };

  const handleNavigate = () => {
    return navigate("/p/fan/lives?tab=schedule");
  };

  const disablePayBtn = () => {
    return cardInfos.cardNumber.length === 19 && cardInfos.cvv.length === 3 && cardInfos.expireDate.length === 5 && checkboxChecked && country;
  };

  const calculateVatAmount = (amount: number): string => {
    const result = (amount * vatPercentage) / 100;
    return result < 0 ? "0.00" : result.toFixed(2);
  };

  const calculateApplePayAmount = () => {
    let baseAmount = rtmpLive?.amount || 0;

    // Step 2: Apply promo discount if present
    if (promoCodeDiscount) {
      baseAmount -= promoCodeDiscount;
    }

    // Step 3: Apply VAT if needed
    if (vatPercentage) {
      baseAmount += Number(calculateVatAmount(baseAmount));
    }

    return baseAmount.toFixed(2);
  };

  return (
    <Spin spinning={isDataLoading()} style={{ maxHeight: "100%" }} indicator={<SpinnerComponent />}>
      <Layout>
        <Layout.Content className="content fanSubscribeContentWrap gradient-background">
          <Col>
            <Row>
              {/* <div className="fanSubscribeHeaderBg"></div> */}
              <div className="fanSubscribeHeaderContent">
                <Row className="relative justify-content-center">
                  {/* <ArrowLeftIconComponent top={6} navigateTo={handleNavigate()} /> */}
                  <img className="header-arrow-left" src={NewArrowLeftIcon} alt="arrow left" style={{ top: 6 }} onClick={handleNavigate} />
                  <Row className="ml-20" align="middle">
                    <img src={LockIcon} width={20} alt="arrow left" />
                    <Typography.Text className="ml-10 header-title-black-28">{t("secure-payment")}</Typography.Text>
                  </Row>
                </Row>
                <Row className="mt-20">
                  <Typography.Text className="fanPaymentRecapLabel">{t("summary")}</Typography.Text>
                </Row>
                <Row className="mt-20">
                  <Typography.Text className="fanPaymentMiddleLabel">{t("rtmp-summary")}</Typography.Text>
                </Row>
                <Row className="d-flex justify-content-between items-center mt-10">
                  <Typography.Text className="fanPaymentMiddleLabel">{t("rtmp-fighters")}</Typography.Text>
                  <Typography.Text className="fanPaymentMiddleLabel">{rtmpLive?.amount} €</Typography.Text>
                </Row>
                {promoCodeDetails && (
                  <Row className="d-flex justify-content-between items-center mt-3">
                    <Typography.Text className="fanPaymentMiddleLabel">{t("promo-code-discount")}</Typography.Text>
                    <Typography.Text className="fanPaymentMiddleLabel">
                      {promoCodeDiscount && "-" + promoCodeDiscount.toFixed(2) + " €"}
                    </Typography.Text>
                  </Row>
                )}
                {country && vatPercentage !== 0 && (
                  <Row className="d-flex justify-content-between items-center mt-3">
                    <Typography.Text className="fanPaymentMiddleLabel tva">{t("including-vat")}</Typography.Text>
                    <Typography.Text className="fanPaymentMiddleLabel tva">
                      {NetPaymentAoumt
                        ? ((NetPaymentAoumt * vatPercentage) / 100).toFixed(2)
                        : (((rtmpLive?.amount || 0) * vatPercentage) / 100).toFixed(2)}
                      €
                    </Typography.Text>
                  </Row>
                )}

                <Row className="mt-20">
                  <Typography.Text className="fanPaymentLargeLabel">{t("promo-code")}</Typography.Text>
                </Row>
                <Row className="mt-7">
                  <InputComponent
                    className="authInput uppercaseInput"
                    placeholder="EX : AB123"
                    disabled={applyPromoCodeLoading}
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value)}
                    //onBlur={promoCodeApply}
                    suffix={
                      <Button onClick={() => promoCodeApply()} className="fanPaymentCodeBtnSuffix" loading={applyPromoCodeLoading}>
                        {t("apply-label")}
                      </Button>
                    }
                  />
                </Row>
              </div>
            </Row>
            <Row className="fanPaymentMainContent">
              {/* <Row className="w-full">
                <Space className="w-full" direction="vertical"> */}
              {/* <Typography.Text className="fanPaymentLargeLabel">{t("payment-method")}</Typography.Text> */}
              {/* <Radio.Group onChange={(e) => setPaymentMethod(e.target.value)} className="w-full">
                    <Space className="w-full" direction="vertical"> */}
              {/* {paymentTypes.map((type, index) => {
                        return <FanPaymentRadioButtonComponent key={index} name={type.name} value={type.value} suffix={type.suffix} />;
                      })} */}

              {/* {applePay && applePay?._canMakePaymentAvailability.APPLE_PAY === true
                        ? paymentRequest && <PaymentRequestButtonElement options={{ paymentRequest }} />
                        : ""} */}
              {/* </Space>
                  </Radio.Group> */}
              {/* </Space>
              </Row> */}

              <Row className="apple-pay-button-row">
                <TheApplePayButton
                  paymentAmount={calculateApplePayAmount}
                  currentUser={currentUser}
                  title={() => "live"}
                  handlePayment={handleApplePayPayment}
                  type={"live"}
                />
              </Row>

              <Row className="w-full ">
                <Space className="w-full" direction="vertical">
                  <Typography.Text className="fanPaymentLargeLabel">{t("country")}</Typography.Text>
                  <CountryDropdownComponent
                    currentValue={country}
                    setCurrentValue={setCountry}
                    countries={countries || []}
                    error={errorFields.includes("country")}
                  />
                </Space>
              </Row>
              {SHIFT4_AS_DEFAULT_PAYMENT_GATEWAY === "shift4" && (
                <>
                  <Row className="w-full">
                    <Space className="w-full" direction="vertical">
                      <Typography.Text className="fanPaymentLargeLabel">{t("card-number")}</Typography.Text>
                      <InputComponent
                        maxLength={19}
                        className="authInput"
                        name="cardNumber"
                        onChange={(e) => {
                          handleCardInfosChange(e);
                        }}
                        value={cardInfos.cardNumber}
                        placeholder="1234 1234 1234"
                        onKeyDown={(e) => setKey(e.key)}
                        inputMode="numeric"
                        status={errorFields.includes("cardNumber") ? "error" : undefined}
                      />
                    </Space>
                  </Row>
                  <Row className="w-full mt-20 mb-20">
                    <Col span={12} className="custom-col">
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Typography.Text className="fanPaymentLargeLabel">{t("expiration-date")}</Typography.Text>
                        <InputComponent
                          className="authInput"
                          inputMode="numeric"
                          placeholder="MM/YY"
                          maxLength={5}
                          name="expireDate"
                          onChange={(e) => {
                            //handleCardInfosChange(e);
                            if (e.target.value.match(CARD_MONTH_YEAR_REGEX)) {
                              const [month, year] = e.target.value.split("/");
                              const inputYear = parseInt(year, 10);
                              const inputMonth = parseInt(month, 10);

                              setCardInfos((preStat) => ({
                                ...preStat,
                                expireDate: e.target.value,
                              }));
                              if (inputYear) {
                                if (inputYear >= parseInt(CURRENT_YEAR, 10) && inputMonth <= 12) {
                                  setCardInfos((preStat) => ({
                                    ...preStat,
                                    expireDate: e.target.value,
                                  }));
                                  setError("");
                                } else {
                                  setError("Enter Valid Expiry Month and Year");
                                }
                              }
                            }
                          }}
                          value={cardInfos.expireDate}
                          onKeyDown={(e) => setKey(e.key)}
                          status={errorFields.includes("monthYear") ? "error" : undefined}
                        />
                      </Space>
                    </Col>
                    <Col span={12} className="custom-col">
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Typography.Text className="fanPaymentLargeLabel">{t("cryptogram")}</Typography.Text>
                        <InputComponent
                          className="authInput"
                          inputMode="numeric"
                          name="cvv"
                          placeholder="CVC"
                          onChange={(e) => {
                            handleCardInfosChange(e);
                          }}
                          value={cardInfos.cvv}
                          maxLength={3}
                          status={errorFields.includes("cvv") ? "error" : undefined}
                        />
                      </Space>
                    </Col>
                  </Row>

                  <Row className="">
                    <Checkbox className="paymentTermsCheckBox" checked={checkboxChecked} onChange={handleCheckboxChange}>
                      {t("payment-terms")}
                    </Checkbox>
                  </Row>
                  <Row className="mt-20 w-full justify-content-center">
                    <Typography.Text className="transaction-text">{t("transaction-appear-bank-statement-universal-media")}</Typography.Text>
                  </Row>

                  <Row className="mt-20 w-full justify-content-center">
                    <img src={InfoPaymentImg} width={200} alt="" />
                  </Row>
                  <Row className="mt-10 w-full justify-content-center">
                    <Typography.Text className="info-company-text">ITDW SRL</Typography.Text>
                  </Row>
                  <Row className="w-full justify-content-center">
                    <Typography.Text className="info-company-text">VAT: BE0789767565</Typography.Text>
                  </Row>
                  <Row className="w-full justify-content-center mb-60">
                    <Typography.Text className="info-company-text">6280, Gerpinnes, Belgium</Typography.Text>
                  </Row>
                  <Row className="fanSubscribeContinueButtonWrap stickyButtonWrapper">
                    <div className="w-button">
                      <AuthButtonComponent onClick={() => handlePayment(null)} label={t("confirm")} disabled={!disablePayBtn()} />
                    </div>
                  </Row>
                </>
              )}
              {/* {payemntGateway === "stripe" && (
                <StripeCheckoutForm
                  setLoading={setIsLoading}
                  checkboxChecked={checkboxChecked}
                  handleCheckboxChange={handleCheckboxChange}
                  loading={isLoading}
                  handlePayment={handlePayment}
                  paymentAmount={calculateAmount}
                />
              )} */}
            </Row>
          </Col>
          {paymentStatus && paymentStatus === "error" ? (
            <FanPaymentPopUp paymentStatus={paymentStatus} setPaymentStatus={setpaymentStatus} username={currentUser?.infos?.username!} />
          ) : (
            <ConfirmationEventPaymentModal paymentStatus={paymentStatus} onClose={handleCloseConfirmModal} />
          )}
        </Layout.Content>
      </Layout>
    </Spin>
  );
};

export default FanPaymentRTMPPage;
